import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";

var identity = require("lodash/identity");

var Slider = require('rc-slider');

var createSliderWithTooltip = Slider.createSliderWithTooltip;
var Range = createSliderWithTooltip(Slider.Range);
import { block } from "../../../core";
export var RangeSlider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RangeSlider, _React$PureComponent);

  function RangeSlider(props) {
    var _this;

    _classCallCheck(this, RangeSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeSlider).call(this, props));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onFinished = _this.onFinished.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RangeSlider, [{
    key: "onChange",
    value: function onChange(_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          min = _ref2[0],
          max = _ref2[1];

      this.props.onChange({
        min: min,
        max: max
      });
    }
  }, {
    key: "onFinished",
    value: function onFinished(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          min = _ref4[0],
          max = _ref4[1];

      this.props.onFinished({
        min: min,
        max: max
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _ref5;

      var _this$props = this.props,
          mod = _this$props.mod,
          className = _this$props.className,
          step = _this$props.step,
          marks = _this$props.marks,
          rangeFormatter = _this$props.rangeFormatter,
          min = _this$props.min,
          max = _this$props.max,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue;
      var bemBlocks = {
        container: block(mod).el
      };
      return React.createElement("div", {
        className: bemBlocks.container().mix(className)
      }, React.createElement(Range, {
        min: min,
        max: max,
        marks: marks || (_ref5 = {}, _defineProperty(_ref5, min, rangeFormatter(min)), _defineProperty(_ref5, max, rangeFormatter(max)), _ref5),
        tipFormatter: rangeFormatter,
        range: true,
        step: step,
        value: [minValue, maxValue],
        onChange: this.onChange,
        onAfterChange: this.onFinished
      }));
    }
  }]);

  return RangeSlider;
}(React.PureComponent);
RangeSlider.defaultProps = {
  mod: "sk-range-slider",
  rangeFormatter: identity
};